type KeysMatching<T, V> = { [K in keyof T]-?: T[K] extends V ? K : never }[keyof T];

const firstDateTime = "1970-01-01T00:00:00.000Z";

export function createSortByDate<Value>(
	dateField: KeysMatching<Value, string | undefined>,
	direction: "asc" | "desc",
): (first: Value, second: Value) => number {
	return function sortByDate(first: Value, second: Value): number {
		const firstField = first[dateField] as string | undefined;
		const secondField = second[dateField] as string | undefined;
		const firstDate = new Date(firstField ?? firstDateTime);
		const secondDate = new Date(secondField ?? firstDateTime);
		const sort = secondDate.getTime() - firstDate.getTime();
		return direction === "desc" ? sort : -sort;
	};
}
